import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import Header from "../../layout/header";
import { Box, Stack, Typography } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import { apiGetPostDetails } from "../../api/post";
import { useNotificationService } from "../../hooks/notification";
import { useLocation } from "react-router-dom";
import {
  PostContentDetails,
  PostContentDetailsDummy,
} from "../../interface/posts";

import { CommentData } from "../../interface/comment";
import UnauthenticatedNavigation from "../../layout/unauthenticated-navigation";
import { getQueryParam } from "../../utils/date-setup";
import UnAuthenticatedPetition from "../../components/unauthenticated-post/unauthenticated-petition";
import UnAuthenticatedReport from "../../components/unauthenticated-post/unauthenticated-report";
import useResponsive from "../../hooks/useResponsive";
import {
  SkeletonLoading,
  SkeletonLoadingUnauthoried,
} from "../../components/ui-elements/skeleton-loading";

const UnAuthenticatedPosts = () => {
  const theme = useTheme();
  const location = useLocation();
  const post_id = getQueryParam(location.search, "post_id");
  const { showNotification } = useNotificationService();
  const [post_details, setPost_details] = useState<PostContentDetails>(
    PostContentDetailsDummy
  );
  const [comment_data, setComment_data] = useState<CommentData[]>([]);
  const isSmall = useResponsive("down", "sm", "xl");

  const { data, isLoading } = useQuery({
    queryKey: ["unauthPost"],
    queryFn: async () => {
      const result = await apiGetPostDetails(Number(post_id ?? 0));
      if (result.status === "error" && "details" in result) {
        showNotification(result.details, "error");
        return {};
      }
      if (result?.status === 200) {
        setPost_details(result.data);
      }
      return result?.data || PostContentDetailsDummy;
    },
  });

  return (
    <>
      {/* Header Menu */}
      <UnauthenticatedNavigation />
      <Box
        sx={{
          background: theme.palette.background.paper,
          pt: "80px",
          minHeight: "90vh",
        }}
      >
        <Header>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Typography variant="h4" sx={{ fontWeight: 500 }}>
              Post Information
            </Typography>
          </Stack>
        </Header>

        {isLoading && (
          <Box
            sx={{
              width: isSmall ? "90%" : 500,
              height: "90vh",
              pt: "6rem",
              mx: "auto",
            }}
          >
            <SkeletonLoadingUnauthoried />
          </Box>
        )}
        {!isLoading &&
          (post_details?.post_type === "petition" ? (
            <UnAuthenticatedPetition
              post_details={post_details}
              comment_data={[]}
            />
          ) : (
            <UnAuthenticatedReport
              post_details={post_details}
              comment_data={[]}
            />
          ))}
      </Box>
    </>
  );
};

export default UnAuthenticatedPosts;
